// extracted by mini-css-extract-plugin
var _1 = "SplashScreen_SplashScreen__3XCfN";
export { _1 as "SplashScreen" }
